import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const updateCheckoutOutboundRatesSettings = {
  name: "updateCheckoutOutboundRatesSettings" as const,
  input: z.object({
    teamId: zExt.objectId(),
    enabled: z.boolean(),
    demoEnabled: z.boolean(),
    hideNonRedoRatesWhenRedoPresent: z.boolean(),
    customCarrierServiceName: z.string().optional(),
    subscriptionsModeEnabled: z.boolean(),
    preventSplitShipmentsRateAddition: z.boolean(),
  }),
  output: z.null(),
};
